// Lightweight toast notifications. Mounts a single host element on first use
// and exposes `toast.success(msg)`, `toast.error(msg)`, `toast.info(msg)`.

import { esc } from '../core/component.js';

const HOST_ID = 'toast-host';
const DEFAULT_TTL = 4000;

function host() {
  let el = document.getElementById(HOST_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = HOST_ID;
    el.className = 'toast-host';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'false');
    document.body.appendChild(el);
  }
  return el;
}

function show(message, kind = 'info', ttl = DEFAULT_TTL) {
  const root = host();
  const node = document.createElement('div');
  node.className = `toast toast-${kind}`;
  node.setAttribute('role', kind === 'error' ? 'alert' : 'status');
  node.innerHTML = `<span class="toast-msg">${esc(message)}</span>`;
  root.appendChild(node);
  // Force reflow so the enter animation runs.
  // eslint-disable-next-line no-unused-expressions
  node.offsetHeight;
  node.classList.add('toast-show');
  const remove = () => {
    node.classList.remove('toast-show');
    node.classList.add('toast-hide');
    setTimeout(() => { if (node.parentNode) node.parentNode.removeChild(node); }, 200);
  };
  const timer = setTimeout(remove, ttl);
  node.addEventListener('click', () => { clearTimeout(timer); remove(); });
  return remove;
}

export const toast = {
  success: (msg, ttl) => show(msg, 'success', ttl),
  error:   (msg, ttl) => show(msg, 'error',   ttl ?? 6000),
  info:    (msg, ttl) => show(msg, 'info',    ttl),
  warn:    (msg, ttl) => show(msg, 'warn',    ttl ?? 5000),
};
